var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1713930290121,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1643,
    id: "mx_n_1713930290122",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555.456 70.4h2.688A30.656 30.656 0 0 1 588.8 101.056v28.288A30.656 30.656 0 0 1 558.144 160h-2.688A30.656 30.656 0 0 1 524.8 129.344v-28.288A30.656 30.656 0 0 1 555.456 70.4z m-460.8 460.8h28.288A30.656 30.656 0 0 1 153.6 561.856v2.688A30.656 30.656 0 0 1 122.944 595.2h-28.288A30.656 30.656 0 0 1 64 564.544v-2.688A30.656 30.656 0 0 1 94.656 531.2z m787.2896-336.6144a30.7712 30.7712 0 0 1 43.4688 0 30.7712 30.7712 0 0 1 0.128 43.3344l-87.3216 87.3152c124.9728 146.1376 116.4864 363.8208-19.4816 499.7888-135.9744 135.968-353.664 144.448-499.808 19.4816L231.616 931.8208a30.7136 30.7136 0 0 1-43.4048-43.4624l87.3152-87.2512c-124.9728-146.1376-116.48-363.8208 19.488-499.7888 135.968-135.9616 353.664-144.448 499.808-19.4816zM794.8672 371.2L364.8 801.248a305.632 305.632 0 0 0 324.544 39.6864A305.5232 305.5232 0 0 0 864 564.5824 304.0256 304.0256 0 0 0 794.8672 371.2zM198.4 204.8c14.5024-9.1328 33.5552-9.4592 44.8 0l25.6 25.6c9.4336 10.4 9.4208 30.0288 0 44.8-14.8288 9.4336-34.4704 9.4208-44.8 0l-25.6-25.6c-9.4656-11.264-9.1328-30.304 0-44.8z",
    fill: "#808080",
    "p-id": 1644
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTheme);
export default __webpack_public_path__ + "static/media/auto-theme.7bae196ae0d33952f6e450e25f07c7d1.svg";
export { ForwardRef as ReactComponent };